import React, { useState } from 'react';
import { X, Send, PhoneCall } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Card, CardContent } from './ui/card';
import { toast } from '../hooks/use-toast';

const QuoteModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', notes: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !formData.email) {
      toast({ title: "Missing Information", description: "Please fill in all required fields.", variant: "destructive" });
      return;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: formData.name, email: formData.email, phone: formData.phone, message: formData.notes, source: 'quote-modal' })
      });
      if (!res.ok) throw new Error('Failed');
      toast({ title: "Quote Request Received!", description: "We'll contact you within 24 hours to discuss your project." });
      if (window.gtag) { window.gtag('event', 'conversion', { 'send_to': 'AW-18269270249/IPghCNXa_sQcEOnhu4dE', 'value': 1.0, 'currency': 'AUD' }); }
      setFormData({ name: '', phone: '', email: '', notes: '' });
      onClose();
    } catch (err) {
      toast({ title: "Error", description: "Something went wrong. Please call us at 0451 945 455.", variant: "destructive" });
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-fadeIn">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>
      <Card className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto border-2 border-red-600/30 shadow-2xl animate-slideUp">
        <CardContent className="p-0">
          <div className="bg-red-600 p-6 relative">
            <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200">
              <X className="w-5 h-5 text-white" />
            </button>
            <div className="pr-12">
              <div className="inline-block px-4 py-1 bg-white/20 rounded-full text-sm font-bold mb-3">
                <span className="text-white">SPECIAL OFFER - 35% OFF</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-2 text-white">Get Your Free Quote</h2>
              <p className="text-lg text-red-100">Transform your space with premium epoxy flooring</p>
            </div>
          </div>
          <div className="p-8">
            <form onSubmit={handleSubmit} className="space-y-6" data-testid="quote-modal-form">
              <div className="grid md:grid-cols-2 gap-6">
                <div><label className="block text-sm font-semibold text-gray-900 mb-2">Full Name *</label><Input name="name" value={formData.name} onChange={handleChange} placeholder="John Smith" required className="h-12 border-gray-300 focus:border-red-600" /></div>
                <div><label className="block text-sm font-semibold text-gray-900 mb-2">Phone Number *</label><Input name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="04XX XXX XXX" required className="h-12 border-gray-300" /></div>
              </div>
              <div><label className="block text-sm font-semibold text-gray-900 mb-2">Email Address *</label><Input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="john@example.com" required className="h-12 border-gray-300" /></div>
              <div><label className="block text-sm font-semibold text-gray-900 mb-2">Project Details</label><Textarea name="notes" value={formData.notes} onChange={handleChange} placeholder="Tell us about your project... (e.g., garage floor, commercial space, square meters, timeline, etc.)" rows={4} className="resize-none border-gray-300" /></div>
              <div className="p-4 rounded-lg bg-red-50 border border-red-200">
                <div className="flex items-start space-x-3">
                  <PhoneCall className="w-5 h-5 text-red-600 mt-0.5" />
                  <div>
                    <p className="font-semibold text-red-900">Fast Response Guaranteed</p>
                    <p className="text-sm text-gray-600">We'll contact you within 24 hours with a detailed quote and free consultation</p>
                  </div>
                </div>
              </div>
              <Button type="submit" size="lg" className="w-full h-14 text-lg transition-all duration-200 hover:scale-105 bg-red-600 hover:bg-red-700 text-white font-semibold shadow-lg" data-testid="quote-modal-submit-btn">
                <Send className="w-5 h-5 mr-2" />Get My 35% OFF Quote Now
              </Button>
              <p className="text-xs text-gray-500 text-center">By submitting this form, you agree to receive communication from Alpha Epoxy Floors Sydney</p>
            </form>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default QuoteModal;
